import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppState } from 'app/shared/common/utils/AppState';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { UtilCommon } from 'app/shared/common/utils/UtilCommon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RoleOfAppAndTenantAutocompleteComponent } from '../role-of-app-and-tenant-autocomplete/role-of-app-and-tenant-autocomplete.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

@Component({
  selector: 'app-quick-create-app',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    TranslocoModule,
  ],
  templateUrl: './quick-create-app.component.html',
  styleUrls: ['./quick-create-app.component.scss']
})
@UntilDestroy()
export class QuickCreateAppComponent implements OnInit {
  public formCreate: FormGroup;
  @Output() submitClicked = new EventEmitter();
  private _currentUser = null;
  constructor(
    private _appState: AppState,
    private _fb: FormBuilder,
    private _dialogRef: MatDialogRef<QuickCreateAppComponent>) { }

  ngOnInit(): void {
    this._initForm();
    this._asyncActions();
  }

  public getErrorMessage(controlName: string, errorType: string): string {
    const control = this.formCreate.get(controlName);

    if (control && control.hasError(errorType)) {
      const errorMessages = {
        required: 'GENERAL.REQUIRED.THIS_FIELD_IS_REQUIRED',
        invalidUrlPattern: 'CONTROL.ERROR.MESSAGE.INVALID_URL',
        invalidPattern: 'FORM_VALIDATE_FAIL',
      };

      return errorMessages[errorType];
    }

    return '';
  }

  public cancel() {
    this._dialogRef?.close();
  }

  public createApp() {
    const formValue = this.formCreate?.getRawValue();
    this.submitClicked.emit({
      appCode: formValue?.appCode,
      tenantCode: this._currentUser?.moreInfo?.tenantCode,
      appUrl: formValue?.appUrl,
      username: formValue?.username,
      role: formValue?.role
    });
  }

  private _initForm() {
    this.formCreate = this._fb.group({
      appCode: ['', Validators.required, UtilCommon.codeValidator()],
      username: ['', Validators.required],
      role: ['', Validators.required, [Validators?.required, UtilCommon.codeValidator()]],
      appUrl: ['', Validators.required, UtilCommon.urlPatternValidator()],
    })
  }
  private _asyncActions() {
    this._appState.getUserInfo().then(rs => {
      this._currentUser = rs
    })
  }

}
